const VELTIZ_LOGO_URL = "https://storage.googleapis.com/veltiz-images/veltiz-logo-shadow2.svg";

export const Logo = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={VELTIZ_LOGO_URL}
        alt="Veltiz"
        className="h-12 w-auto min-w-0 object-contain"
      />
    </div>
  );
};

